// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__3sJ0F","tabs_wrapper":"styles_tabs_wrapper__1NSad","tab":"styles_tab__10h8W","active":"styles_active__2bsbe"};